import React from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

/**
 * Smooth fade + subtle rise on route change. Re-keyed on pathname so
 * navigating between /app/* pages replays the entrance.
 */
export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
